import React from 'react';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const ShowMoreButton = ({
  handleButtonClick,
  isShowingLess,
  additionalStyle,
  isDisabled,
  ctaText,
}: {
  handleButtonClick: () => void;
  isShowingLess: boolean;
  additionalStyle?: any;
  isDisabled?: boolean;
  ctaText?: string;
}) => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down(900));

  return (
    <Button
      size="small"
      sx={{
        marginLeft: 'auto',
        marginTop: '5px',
        fontSize: isMobileView ? '12px' : '14px',
        color: '#000',
        textTransform: 'capitalize',
        ...(additionalStyle ? additionalStyle : {}),
      }}
      onClick={handleButtonClick}
    >
      {isShowingLess ? (ctaText ? ctaText : 'Show More') : 'Show Less'}
      {isDisabled && <LockIcon sx={{ fontSize: '14px', marginLeft: '5px' }} />}
    </Button>
  );
};

export default ShowMoreButton;
